// assets/service-fields.js
document.addEventListener('DOMContentLoaded', function(){
  const forms = document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]');
  if(!forms || forms.length === 0) return;

  forms.forEach(function(form){
    const fulfillment = form.querySelector('#prop_fulfillment');
    const date = form.querySelector('#prop_date');
    const time = form.querySelector('#prop_time');
    const phone = form.querySelector('#prop_phone');
    const address = form.querySelector('#prop_address');

    if(!fulfillment || !date) return;

    const min = new Date(); min.setDate(min.getDate() + 1);
    date.min = min.toISOString().split('T')[0];

    function toggleFields(){
      if(fulfillment.value === 'Delivery'){
        date.required = true;
        time.required = true;
        phone.required = true;
        address.required = true;
      } else {
        date.required = false;
        time.required = false;
        phone.required = false;
        address.required = false;
      }
    }
    fulfillment.addEventListener('change', toggleFields);
    toggleFields();

    form.addEventListener('submit', function(e){
      if(fulfillment.value === 'Delivery'){
        const phoneVal = phone.value ? phone.value.trim() : '';
        const digits = phoneVal.replace(/[^\d]/g,'');
        if(!phoneVal || digits.length < 7){
          e.preventDefault(); alert('Please enter a valid contact phone for Delivery.'); phone.focus(); return false;
        }
        if(!date.value){ e.preventDefault(); alert('Please choose a service date.'); date.focus(); return false; }
        if(time && !time.value){ e.preventDefault(); alert('Please choose a time slot.'); time.focus(); return false; }
        if(!address.value || !address.value.trim()){ e.preventDefault(); alert('Please enter the delivery address.'); address.focus(); return false; }
      }
      return true;
    });
  });
  // ---- paste this at the end of assets/service-fields.js ----
(function () {
  'use strict';

  // Helpers
  const qs = (s, ctx) => (ctx || document).querySelector(s);
  const qsa = (s, ctx) => Array.from((ctx || document).querySelectorAll(s));

  // Collect attributes from the cart UI (attributes[...] and attr_* IDs)
  function collectAttrs() {
    const attrs = {};
    qsa('input[name^="attributes["], textarea[name^="attributes["], select[name^="attributes["]').forEach(el => {
      const m = el.name.match(/attributes\[(.+?)\]/);
      if (m) attrs[m[1]] = (el.value || '').toString().trim();
    });
    // fallback IDs
    const map = {
      'Fulfillment Option': '#attr_fulfillment',
      'Service Date': '#attr_date_native, #attr_date_manual',
      'Service Time': '#attr_time',
      'Contact Phone': '#attr_phone',
      'Delivery Address': '#attr_address',
      'Personalization': '#attr_personalization'
    };
    Object.keys(map).forEach(k => {
      if (attrs[k]) return;
      const el = qs(map[k]);
      if (el) attrs[k] = (el.value || '').toString().trim();
    });
    return attrs;
  }

  // Basic validation: if delivery -> require date/time/phone/address; if pickup -> require phone
  function validateAttrs(attrs) {
    const missing = [];
    const fulfillment = (attrs['Fulfillment Option'] || '').toLowerCase();
    if (fulfillment === 'delivery' || fulfillment === 'deliver') {
      if (!attrs['Service Date']) missing.push({key: 'Service Date', selector: 'input[name="attributes[Service Date]"], #attr_date_native, #attr_date_manual'});
      if (!attrs['Service Time']) missing.push({key: 'Service Time', selector: 'select[name="attributes[Service Time]"], #attr_time'});
      if (!attrs['Contact Phone']) missing.push({key: 'Contact Phone', selector: 'input[name="attributes[Contact Phone]"], #attr_phone'});
      if (!attrs['Delivery Address']) missing.push({key: 'Delivery Address', selector: 'textarea[name="attributes[Delivery Address]"], #attr_address'});
    } else {
      if (!attrs['Contact Phone']) missing.push({key: 'Contact Phone', selector: 'input[name="attributes[Contact Phone]"], #attr_phone'});
    }
    return { ok: missing.length === 0, missing };
  }

  // Save attributes to cart via Shopify, returns Promise
  function saveAttrs(attrs) {
    const payload = {};
    Object.keys(attrs).forEach(k => { if (attrs[k]) payload[k] = attrs[k]; });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ attributes: payload })
    }).then(r => {
      if (!r.ok) throw new Error('update failed');
      return r.json();
    });
  }

  // Focus first missing field
  function focusMissing(missing) {
    if (!missing || !missing.length) return;
    const sel = missing[0].selector;
    try { const el = document.querySelector(sel); if (el) el.focus(); } catch (e) {}
  }

  // Disable/enable accelerated checkout UI (best-effort across variants)
  function setAcceleratedDisabled(disabled) {
    // hide/disable known containers that host wallet buttons
    qsa('shopify-accelerated-checkout-cart, shopify-accelerated-checkout, .shopify-payment-button, .additional-checkout-buttons, #dynamic-checkout-cart').forEach(el => {
      try {
        if (disabled) {
          el.setAttribute('data-disabled-by-attrs','true');
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.45';
        } else {
          if (el.getAttribute('data-disabled-by-attrs')) {
            el.removeAttribute('data-disabled-by-attrs');
            el.style.pointerEvents = '';
            el.style.opacity = '';
          }
        }
      } catch (e) {}
    });
  }

  // Intercept user click/submit that intends to go to checkout
  function shouldInterceptClick(target) {
    if (!target) return false;
    if (target.closest && target.closest('a[href*="/checkouts"], a[href$="/checkout"], button[name="checkout"], input[name="checkout"], [data-checkout-button], .cart__checkout-button')) return true;
    // accelerated wallet elements
    if (target.closest && (target.closest('shopify-accelerated-checkout-cart') || target.closest('.shopify-payment-button') || target.closest('shopify-accelerated-checkout'))) return true;
    return false;
  }

  // Core handler: intercept, validate, save attrs, redirect
  function handleAttemptToCheckout(evt) {
    // ignore non-left clicks or modifier keys
    if (evt && evt.button !== 0) return;
    if (evt && (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey)) return;

    const target = evt ? evt.target : null;
    if (!shouldInterceptClick(target)) return;

    // If service fields not present, do nothing
    if (!document.querySelector('#cartServiceProperties') && !document.querySelector('input[name^="attributes["]')) {
      return;
    }

    // collect & validate
    const attrs = collectAttrs();
    const valid = validateAttrs(attrs);

    if (!valid.ok) {
      if (evt) { evt.preventDefault(); evt.stopImmediatePropagation(); }
      alert('Please complete required service fields before checking out:\\n\\n' + valid.missing.map(m => m.key).join('\\n'));
      focusMissing(valid.missing);
      return false;
    }

    // valid -> prevent default, save attrs, then go to checkout
    if (evt) { evt.preventDefault(); evt.stopImmediatePropagation(); }

    // UI lock (best-effort)
    try { const btn = target.closest && (target.closest('button') || target); if (btn) { btn.setAttribute('aria-disabled','true'); btn.classList && btn.classList.add('is-loading'); } } catch (e) {}

    saveAttrs(attrs).then(() => {
      window.location.href = '/checkout';
    }).catch(err => {
      console.error('saving attributes failed', err);
      alert('Could not save service info — please try again.');
    });

    return false;
  }

  // Intercept form submit (capture) and programmatic submits
  function attachInterceptors() {
    // capture-phase click listener (catches most user clicks)
    document.addEventListener('click', function (e) {
      try { if (shouldInterceptClick(e.target)) handleAttemptToCheckout(e); } catch (err) {}
    }, true);

    // capture-phase submit listener (catches normal submits)
    document.addEventListener('submit', function (e) {
      // detect if this submit is intended to checkout (submitter might be absent)
      const submitter = e.submitter || document.activeElement;
      if (submitter && shouldInterceptClick(submitter)) {
        handleAttemptToCheckout(e);
      }
    }, true);

    // override HTMLFormElement.prototype.submit to catch programmatic submits
    try {
      const nativeSubmit = HTMLFormElement.prototype.submit;
      HTMLFormElement.prototype.submit = function () {
        // if this form is the cart form (id="cart" or action contains /cart) -> validate
        const idMatches = this.id === 'cart';
        const actionMatches = (this.getAttribute && this.getAttribute('action') && this.getAttribute('action').indexOf('/cart') !== -1);
        if (idMatches || actionMatches) {
          const attrs = collectAttrs();
          const valid = validateAttrs(attrs);
          if (!valid.ok) {
            alert('Please complete required service fields before checking out:\\n\\n' + valid.missing.map(m => m.key).join('\\n'));
            focusMissing(valid.missing);
            return; // block programmatic submit
          }
          // save then submit (synchronously submitting after save)
          saveAttrs(attrs).finally(() => {
            nativeSubmit.apply(this);
          });
        } else {
          nativeSubmit.apply(this);
        }
      };
    } catch (e) {
      console.warn('Could not override HTMLFormElement.submit', e);
    }
  }

  // Live-enable/disable accelerated buttons depending on current validity (so wallets disabled until fields filled)
  function watchAndToggleAccelerated() {
    function update() {
      const attrs = collectAttrs();
      const valid = validateAttrs(attrs);
      setAcceleratedDisabled(!valid.ok);
    }
    // run once and then on input changes
    update();
    qsa('#cartServiceProperties input, #cartServiceProperties select, #cartServiceProperties textarea, input[name^="attributes["]').forEach(el => {
      el.addEventListener('input', update);
      el.addEventListener('change', update);
    });
    // observe DOM for injected buttons (wallets)
    const obs = new MutationObserver(() => update());
    obs.observe(document.body, {childList: true, subtree: true});
  }

  // Init when DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    attachInterceptors();
    watchAndToggleAccelerated();
    // ensure accelerated buttons initially disabled if not valid
    setTimeout(() => { const attrs = collectAttrs(); const valid = validateAttrs(attrs); if (!valid.ok) setAcceleratedDisabled(true); }, 500);
  });

})();

});
